import Vue from 'vue';
import store from '@/store';

/**
 * 权限控制
 * 指令用法：
 *  - 在需要控制 hasAuth 级别权限的组件上使用 v-hasAuth:[method] , 如下：
 *    <i-button v-hasAuth:add >添加用户</a-button>
 *    <a-button v-hasAuth="['admin', 'delete']">删除用户</a-button>
 *    <a v-hasAuth:edit @click="edit(record)">修改</a>
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 */
Vue.directive('hasAuth', {
  inserted(el, binding) {
    const permissionList = [...store.state.authorities];
    const permissionKey = binding.arg;
    const permissionKeys = [permissionKey].concat(binding.value || []);
    const hasAction = permissionList.some(item => permissionKeys.includes(item));
    if (!hasAction) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.style.display = 'none';
      }
    }
  },
});


Vue.directive('downLoad', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      const a = document.createElement('a');
      // let url = baseUrl + binding.value // 若是不完整的url则需要拼接baseURL
      const url = binding.value; // 完整的url则直接使用
      const httpsUrl = url.replace('http://3vj-outerapi.oss-cn-shenzhen-internal.aliyuncs.com/', 'https://3vj-outerapi.3vjia.com/');
      // 这里是将url转成blob地址，
      fetch(httpsUrl).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob);
        // console.log(a.href)
        // a.download = '' // 下载文件的名字
        // 下载文件的名字
        a.download = url.split('/')[url.split('/').length - 1];
        document.body.appendChild(a);
        a.click();
        return a;
      }).then(doc => {
        document.body.removeChild(doc);
      });
    });
  },
});
